/*
 * @Author: Han
 * @Date: 2022-02-22 13:55:59
 * @LastEditors: Han
 * @LastEditTime: 2022-02-22 14:00:15
 * @FilePath: \release\console\console\src\http\moudules\accountManagement.js
 */
import axios from '../axios'
// 搜索列表
export const getUserList = (data) => {
  return axios({
    url: '/con/manage/user/list',
    method: 'POST',
    data
  })
}
// 冻结账号
export const getUpdate_user_status = (data) => {
  return axios({
    url: '/con/manage/user/update_user_status',
    method: 'POST',
    data
  })
}
// // 重置密码
export const reset_passwd= (data) => {
  return axios({
    url: '/con/manage/user/reset_passwd',
    method: 'POST',
    data
  })
}
// 查询所有角色
export const getAllRole = (data) => {
  return axios({
    url: '/con/manage/role/get_all_role',
    method: 'POST',
  })
}
// // 添加账号
export const postAddAccount = (data) => {
  return axios({
    url: '/con/manage/user/save',
    method: 'POST',
    data
  })
}
//查看账号是否重复
export const checkAccountName = (data) => {
  return axios({
    url: '/con/manage/user/checkAccountName',
    method: 'POST',
    data
  })
}
// 查看角色名称是否重复
export const checkRoleName = (data) => {
  return axios({
    url: '/con/manage/role/checkRoleName',
    method: 'GET',
    data
  })
}

// // 删除账号
export const postDelete = (data) => {
  return axios({
    url: '/con/manage/user/delete',
    method: 'POST',
    data
  })
}
// // 编辑账号
export const accountUpdate = (data) => {
  return axios({
    url: '/con/manage/user/update',
    method: 'POST',
    data
  })
}












// WEBPACK FOOTER //
// ./src/http/moudules/accountManagement.js